import './Marquee.scss';
import React, { FC } from 'react';
import Logo from '@/components/extra/Logo/Logo';
import LogoDws from '@/components/extra/LogoDws/LogoDws';

type MarqueeProps = Record<string, never>;

const Marquee: FC<MarqueeProps> = () => {
    return (
        <header className="Marquee">
            <Logo className="Marquee_logo" />
            <LogoDws className="Marquee_logoDws" />
        </header>
    );
};

export default Marquee;
